import { useMemo } from 'react';

import { ResizeObserver as polyfill } from '@juggle/resize-observer';
import { mergeRefs } from 'react-merge-refs';
import useMeasureExt from 'react-use-measure';

/**
 * This `useMeasure` hook combines potentially a plain ref that the client provides with a ref used by react-use-measure
 * this is important because react-measure uses a functionnal ref that cannot be used afterwards by the client to eg manipulate the DOM
 * also provides a polyfill to react-use-measure for ResizeObserver compatibility with Safari etc...
 */
export const useMeasure = (
  extRef: Parameters<typeof mergeRefs>[0][0],
  delay: number
) => {
  // instantiate a functional ref with the react-measure resize observer
  const options = useMemo(
    () => ({
      debounce: delay,
      scroll: false,
      polyfill
    }),
    [delay]
  );
  const result = useMeasureExt(options);

  // merge with client ref
  if (extRef) {
    result[0] = mergeRefs([extRef, result[0]]);
  }

  return result;
};
